import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import MinimalLayout from '../components/layout/MinimalLayout';

const AccountCreationPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState<string | null>(null);

  const questionnaireData = location.state?.questionnaireData;

  useEffect(() => {
    console.log('AccountCreationPage rendered. Questionnaire Data:', questionnaireData);
    if (!questionnaireData) {
      // console.warn('No questionnaire data found, redirecting to start of flow.');
      // navigate('/instrument-selection');
    }
  }, [questionnaireData]);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError(null);

    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    if (password.length < 8) {
      setError('Password must be at least 8 characters long.');
      return;
    }
    // Basic email validation (can be more robust)
    if (!email.includes('@') || !email.includes('.')) {
        setError('Please enter a valid email address.');
        return;
    }

    console.log('Proceeding to confirmation page with email and password.');
    navigate('/confirm-details', {
      state: {
        questionnaireData,
        email,
        password, // Password will be passed to confirmation, then to final creation.
      }
    });
  };

  return (
    <MinimalLayout>
      <div className="min-h-screen bg-gradient-to-b from-white to-blue-50 flex flex-col items-center justify-start p-4 pt-24 sm:pt-32">
        <div className="w-full max-w-md bg-white p-8 sm:p-10 rounded-xl shadow-2xl">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900 text-center mb-8">
            Create Your LessonLynx Account
          </h1>
          
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                Email address
              </label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none placeholder-gray-500 shadow-sm"
              />
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="new-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none placeholder-gray-500 shadow-sm"
              />
            </div>

            <div>
              <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700 mb-1">
                Confirm Password
              </label>
              <input
                id="confirmPassword"
                name="confirmPassword"
                type="password"
                autoComplete="new-password"
                required
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none placeholder-gray-500 shadow-sm"
              />
            </div>

            {error && (
              <p className="text-sm text-red-600 bg-red-100 p-3 rounded-md">{error}</p>
            )}

            <div>
              <button
                type="submit"
                className="w-full flex justify-center py-3.5 px-4 border border-transparent rounded-full shadow-lg text-lg font-semibold text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 transition-all transform hover:-translate-y-0.5"
              >
                Review Your Information
              </button>
            </div>
          </form>
           <p className="mt-8 text-xs text-gray-500 text-center">
              By creating an account, you agree to our (not yet existing) Terms of Service and Privacy Policy.
            </p>
        </div>
      </div>
    </MinimalLayout>
  );
};

export default AccountCreationPage; 